export default __webpack_public_path__ + "static/media/demo3.8c48c0b9.jpg";